export default "__VITE_ASSET__D8aDzBZX__"